import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import localSettings from "@app/config/LocalSettings";

import Field, { FieldProperties } from "./Field";

class UniqueIdField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      features: [
        FieldFeature.SORTABLE,
        FieldFeature.FILTERABLE,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.NON_ADDABLE_FORM_FIELD,
        FieldFeature.NON_INTEGRATION,
        FieldFeature.HISTORY_FIELD,
        FieldFeature.DETAILS,
      ],
      type: FieldType.STRING,
      ...data,
    });
  }

  getFormattedCsvValueFor(entity: unknown) {
    const formattedValue = super.getFormattedCsvValueFor(entity);
    const useApostrophe = localSettings.getUidExportSetting();
    return `${useApostrophe ? "'" : ""}${formattedValue}`;
  }
}

export default UniqueIdField;
